import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CRMRoles } from '../../../pages/manage-connection-group/models/crm-roles';

@Injectable({
  providedIn: 'root',
})
export class CRMService {
  private http: HttpClient = inject(HttpClient);
  private adminApiBaseUrl = environment.apiBaseUrl + '/api/admin';
  private apiBaseUrl = environment.apiBaseUrl + '/api';

  getCRMRoles(): Observable<CRMRoles[]> {
    return this.http
      .get<CRMRoles[]>(`${this.adminApiBaseUrl}/crm/roles`)
      .pipe(
        map((roles) =>
          roles.filter(
            (role) => role.role_name.toLowerCase() !== 'organization',
          ),
        ),
      );
  }

  getCRMLeadID(uniqueId: string): Observable<string> {
    return this.http
      .get<{ crm_lead_id: string }>(
        `${this.apiBaseUrl}/record/${uniqueId}/crm`,
        {
          headers: {
            'X-Skip-Loader': 'true',
          },
        },
      )
      .pipe(map((response) => response.crm_lead_id));
  }
}
